import React, { useContext, useEffect } from 'react';
import { AuthContext } from './AuthContext';

const InactivityModal = () => {
    const { countdown, cancelAutoLogout, auth } = useContext(AuthContext);
    const [showModal, setShowModal] = React.useState(false);

    useEffect(() => {
        // // console.log(`Modal countdown check: ${countdown}`);
        if (countdown < 60 && countdown > 0) {
            setShowModal(true);
        } else if (countdown === 60) {
            setShowModal(false);
        }
    }, [countdown]);

    const handleStayLoggedIn = () => {
        cancelAutoLogout();
        setShowModal(false);
    };

    if (!showModal || !auth.isAuthenticated) return null;

    return (
        <div className="inactivity-modal-overlay">
            <div className="inactivity-modal">
                <h2>Session Timeout Warning</h2>
                <p>Your session will expire in <strong>{countdown}</strong> seconds due to inactivity.</p>
                <div className="inactivity-modal-actions">
                    <button className="stay-logged-in-btn" onClick={handleStayLoggedIn}>
                        Re - Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InactivityModal;
